import DyeingProduction from "../../Screen/Produccion/KPIs/DyeingProductionScreen";
import KnittingProduction from "../../Screen/Produccion/KPIs/KnittingProductionScreen";
import FinishingProduction from "../../Screen/Produccion/KPIs/FinishingProductionScreen";
import TrackingLot from "../../Screen/Produccion/TrakingLot/TrackingLotScreen";
import ExportProduction from "../../Screen/Produccion/KPIs/ExportProduction";
import InventarioMensualHilazaScreen from "../../Screen/Produccion/BodegaHilaza/InventarioMensual/InventarioMensualHilazaScreen";
import IngresosHilazaScreen from "../../Screen/Produccion/BodegaHilaza/IngresosHilaza/IngresosHilazaScreen";
import SalidasHilazaScreen from "../../Screen/Produccion/BodegaHilaza/SalidasHilaza/SalidasHilazaScreen";
import ControlQCScreen from "../../Screen/Produccion/QuimicosColorantes/ControlQC/ControlQCScreen";
import InventarioGeneralQCScreen from "../../Screen/Produccion/QuimicosColorantes/InventarioGeneral/InventarioGeneralQCScreen";
import ControlMSDSScreen from "../../Screen/Produccion/QuimicosColorantes/ControlMSDS/ControlMSDSScreen";
import DyeingMachineWorkflow from "../../Screen/Produccion/Dyeing/DyeingMachineWorkflow";
import PartidasAdicionesScreen from "../../Screen/Produccion/Dyeing/PartidasAdicionesScreen";


export const ProductionRoutes = [
  {
    path: 'Production/TrackingLot',
    permiso: 19,
    element: <TrackingLot openDialog={true} />,
  },
  {
    path: 'Production/Export',
    permiso: 18,
    element: <ExportProduction />,
  },
  {
    path: 'Production/Dyeing',
    permiso: 15,
    element: <DyeingProduction />,
  },
  {
    path: 'Production/Knitting',
    permiso: 16,
    element: <KnittingProduction />,
  },
  {
    path: 'Production/Finishing',
    permiso: 17,
    element: <FinishingProduction />,
  },
  {
    path: 'Produccion/InventarioHilaza',
    permiso: 45,
    element: <InventarioMensualHilazaScreen />,
  },
  {
    path: 'Produccion/IngresosHilaza',
    permiso: 46,
    element: <IngresosHilazaScreen />,
  },
  {
    path: 'Produccion/SalidasHilaza',
    permiso: 47,
    element: <SalidasHilazaScreen />,
  },

  // QUIMICOS Y COLORANTES
  {
    path: 'Produccion/QC/ControlQC',
    permiso: 42,
    element: <ControlQCScreen />,
  },
  {
    path: 'Produccion/QC/InventarioGeneral',
    permiso: 43,
    element: <InventarioGeneralQCScreen />,
  },
  {
    path: 'Produccion/QC/PlantaTratamiento',
    permiso: 54,
    element: <ControlQCScreen plantaTratamiento={true} />,
  },
  {
    path: 'Produccion/QC/ControlMSDS',
    permiso: 55,
    element: <ControlMSDSScreen />,
  },
  {
    path: 'Produccion/DyeingMachineWorkflow',
    permiso: 146,
    element: <DyeingMachineWorkflow />,
  },
  {
    path: 'Produccion/Dyeing/PartidasAdiciones',
    permiso: 147,
    element: <PartidasAdicionesScreen />,
  },


];

export default ProductionRoutes;